import React, { useState, useEffect } from 'react';
import { Dropdown, Tab, Nav } from 'react-bootstrap';
import { NavLink, useParams } from 'react-router-dom';
import CustomerDetails from './customer-detail';
import SentToInsuranceBroker from '../detail/SentToInsuranceBroker';
import InsurancePolicyShared from '../detail/InsurancePolicyShared';
import UsePolicyForm from '../detail/UsePolicyForm';
import PolicyTermsFinalizedForm from '../detail/PolicyTermsFinalizedForm';
import PaymentType from './inbound-outbound-payment/PaymentType';
import InsurancePremiumPayment from '../detail/InsurancePremiumPayment';

import LoanExpected from '../quotes/Index';
import DocumentUpload from './DocumentUpload';
import { useSelector } from 'react-redux';
import { APP_TYPE_WITH_UCF, STATUS_SUB_STATUS, ROLE_FEATURES, APP_TYPE_STANDALONE, APP_TYPE_RENEWAL, APP_TYPE_AGENCY, INBOUND_PAYMENT_FROM_OTO_INSURANCE, INBOUND_PAYMENT_FROM_INSURANCE_PARTNER, REFERRAL_FEE_PAYOUT, INSURANCE_PAYMENT_FROM_INSURANCE_PARTNER_TO_OTO, INSURANCE_PAYMENT_FROM_AGENCY_TO_INSURANCE_PARTNER, INSURANCE_PAYMENT_FROM_OTO_TO_INSURANCE_PARTNER, INSURANCE_PAYMENT_FROM_AGENCY_TO_OTO_INSURANCE, REFERRAL_FEE_PAYOUT_OUTBOUND, AGENCY_STATUS, FEATURE_LISTING, COUNTRY_CODE, SENT_TO_VERIFICATION_IDS } from "@src/config/constant";
import MarkAsLostPopup from './MarkAsLostPopup';
import ReopenPopup from './ReopenPopup';
import * as HELPER from "@src/config/helper";
import AgencyInboundOutBoundPayment from './inbound-outbound-payment/AgencyInboundOutBoundPayment';
import InsurerPartnerPayment from './InsurerPartnerPayment';
import { useLanguage } from '@src/context/LanguageContext';


export default function LeadDetailTabsId(props: any): ReturnType<React.FC> {

    const queryParams = useParams();
    const [markLostPopup, setMarkLostPopup] = useState(false);
    const [reopenPopup, setReopenPopup] = useState(false);
    const [subRoute, setSubRoute] = useState<any>();
    const [leadHashId, setLeadHashId] = useState(props.leadHashId);
    const [leftSideTabs, setLeftSideTabs] = useState<any>([]);
    const {translations} = useLanguage();
    // const tabVisiblity: any = {
    //     "withUcf": {
    //         "customer": { "outbound": ["broker", "sales_team"] },
    //         "broker": { "outbound": ["sales_team"] },
    //         "sales_team": { "outbound": ["broker"] }
    //     },
    //     "standalone": {
    //         "customer": { "outbound": ["broker", "sales_team"] },
    //         "broker": { "outbound": ["sales_team"] }
    //     },
    //     "agency": {
    //         "oto_insurance": { "outbound": ["broker", "sales_team"] },
    //         "insurance_partner": { "outbound": ["sales_team"] }
    //     }
    // };

    let [activeTab, setActiveTab] = useState<string>('first')
    const [menuExpanded, setMenuExpanded] = useState<any>({ customer_details: true, inbound_payment: true, outbound_payment: true });

    const insuranceState = useSelector((state: any) => state.insurance);
    let statusId = (insuranceState.leadDetail && insuranceState.leadDetail.status_id) ? +insuranceState.leadDetail.status_id : 0;
    let prevStatusId = insuranceState?.leadDetail?.prev_status_id;
    let currSubStatusId = insuranceState?.leadDetail?.sub_status_id;


    useEffect(() => {
        if (!leadHashId) {
            setLeadHashId(props.leadHashId);
        }
        // eslint-disable-next-line
    }, [props.leadHashId])

    useEffect(() => {
        if (queryParams && queryParams.type && (subRoute !== queryParams["type"])) {
            setSubRoute(queryParams["type"]);
        }
        // eslint-disable-next-line
    }, [queryParams]);

    let allStatus = insuranceState?.leadDetail?.prev_status_sub_status_ids
    let isLeadPushToColl = insuranceState?.leadDetail?.isLeadPushToColl
    useEffect(() => {
        let appType = ""
        if (insuranceState.leadDetail && insuranceState.leadDetail.application_type_id) {
            if ((+insuranceState.leadDetail.application_type_id === APP_TYPE_WITH_UCF)) {
                appType = "withUcf"
            }
            if (([APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(+insuranceState.leadDetail.application_type_id))) {
                appType = "standalone"
            }
            if ((+insuranceState.leadDetail.application_type_id === APP_TYPE_AGENCY)) {
                // eslint-disable-next-line
                appType = "agency"
            }

        }

        let updatedLeftBar: any = [
            {
                name: translations.Insurance?.['Customer Details'] || translations.commonMsg?.loading,
                key: "customer_details",
                isVisible: FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['CUSTOMER_DETAILS'],
                order: 1,
                url: `/details/personal-details/${insuranceState.leadDetail.hashId}`,
                activeRoutes: ['personal-details', 'residential-details', 'vehicle-details'],
                isClickable: true,
                completedOnSubStatus: true,//STATUS_SUB_STATUS['subStatus']['customer_details_filled'],
                isLinkAccessible: ROLE_FEATURES['customer_details'],
                child: [
                    {
                        name: translations.Insurance?.['Personal Details'] || translations.commonMsg?.loading,
                        key: "personal_details",
                        isVisible: FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['CUSTOMER_DETAILS']['PERSONAL_DETAILS'],
                        url: `/details/personal-details/${insuranceState.leadDetail.hashId}`,
                        activeRoutes: ['personal-details'],
                        completedOnSubStatus: true,//STATUS_SUB_STATUS['subStatus']['customer_details_filled'],
                        isClickable: true,
                        isLinkAccessible: ROLE_FEATURES['personal_details'],

                    },
                    {
                        name: translations.Insurance?.['Residential Information'] || translations.commonMsg?.loading,
                        key: "residential_information",
                        isVisible: FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['CUSTOMER_DETAILS']['RESIDENTIAL_DETAILS'],
                        url: `/details/residential-details/${insuranceState.leadDetail.hashId}`,
                        activeRoutes: ['residential-details'],
                        completedOnSubStatus: true,//STATUS_SUB_STATUS['subStatus']['customer_details_filled'],
                        isClickable: true,
                        isLinkAccessible: ROLE_FEATURES['residential_details'],

                    },
                    {
                        name: translations.Insurance?.['Vehicle Details'] || translations.commonMsg?.loading,
                        key: "vehicle_details",
                        isVisible: FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['CUSTOMER_DETAILS']['VEHICLE_DETAILS'],
                        url: `/details/vehicle-details/${insuranceState.leadDetail.hashId}`,
                        activeRoutes: ['vehicle-details'],
                        completedOnSubStatus: true,//STATUS_SUB_STATUS['subStatus']['customer_details_filled'],
                        isClickable: true,
                        isLinkAccessible: ROLE_FEATURES['vehicle_details'],

                    },
                    {
                        name:  translations.Insurance?.['Other Details'] || translations.commonMsg?.loading,
                        key: "other_details",
                        isVisible: (FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['CUSTOMER_DETAILS']['OTHER_DETAILS']) && (COUNTRY_CODE !== 'id' && insuranceState.leadDetail.application_type_id === APP_TYPE_AGENCY ? false : true),
                        url: `/details/other-details/${insuranceState.leadDetail.hashId}`,
                        activeRoutes: ['other-details'],
                        completedOnSubStatus: true,//STATUS_SUB_STATUS['subStatus']['customer_details_filled'],
                        isClickable: true,
                        isLinkAccessible: ROLE_FEATURES['vehicle_details'],

                    },
                    {
                        name: translations.Insurance?.['Payment Details'] || translations.commonMsg?.loading,
                        key: "payment_details",
                        isVisible: (FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['CUSTOMER_DETAILS']['PAYMENT_DETAILS']) && (+insuranceState?.leadDetail?.paid_by_customer === 1) ? true : false,
                        url: `/details/payment-details/${insuranceState.leadDetail.hashId}`,
                        activeRoutes: ['payment-details'],
                        completedOnSubStatus: true,//STATUS_SUB_STATUS['subStatus']['customer_details_filled'],
                        isClickable: true,
                        isLinkAccessible: ROLE_FEATURES['payment_details'],

                    }
                ]
            },
            {
                name: translations.Insurance?.['Sent to Insurance Broker'] || translations.commonMsg?.loading,
                key: "sent_to_insurace_broker",
                isVisible: FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['SENT_TO_INSURANCE_BROKER'],
                order: 2,
                child: [],
                url: `/details/sent-to-insurance-broker/${insuranceState.leadDetail.hashId}`,
                activeRoutes: ['sent-to-insurance-broker'],
                isClickable: true,
                completedOnSubStatus: (!SENT_TO_VERIFICATION_IDS.includes(insuranceState.leadDetail?.sent_to_verification) && allStatus && allStatus.includes('2-3')) || ((insuranceState.leadDetail.is_policy_shared_broker_skipped || insuranceState.leadDetail.policy_shared_broker_source) ? true : false),//STATUS_SUB_STATUS['subStatus']['sent_to_insurance_broker'],
                isLinkAccessible: ROLE_FEATURES['send_to_insurance_broker'],

            },
            {
                name:  translations.Insurance?.['Insurance Policy Generated'] || translations.commonMsg?.loading,
                key: "insuance_policy_generated",
                isVisible: FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['INSURANCE_POLICY_GENERATED'],
                order: 3,
                child: [],
                url: `/details/insurance-policy-generated/${insuranceState.leadDetail.hashId}`,
                activeRoutes: ['insurance-policy-generated'],
                isClickable: (allStatus && allStatus.includes('2-3')) || ((insuranceState.leadDetail.is_policy_shared_broker_skipped || insuranceState.leadDetail.policy_shared_broker_source) ? true : false),
                completedOnSubStatus: (allStatus && allStatus.includes('3-4')) || insuranceState.leadDetail.policy_generate_id ? true : false,//STATUS_SUB_STATUS['subStatus']['policy_generated'],
                isLinkAccessible: ROLE_FEATURES['insurance_policy_generated'],

            },
            {
                name: translations.Insurance?.['Policy Terms Finalized'] || translations.commonMsg?.loading,
                key: "policy_terms_finalized",
                isVisible: FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['POLICY_TERMS_FINALIZED'],
                order: 4,
                child: [],
                url: `/details/policy-terms-finalized/${insuranceState.leadDetail.hashId}`,
                activeRoutes: ['policy-terms-finalized'],
                isClickable: (allStatus && allStatus.includes('3-4')) || insuranceState.leadDetail.policy_generate_id ? true : false,
                completedOnSubStatus: (allStatus && allStatus.includes(`3-${STATUS_SUB_STATUS['subStatus']['policy_terms_finalized']}`)) ? true : false,
                isLinkAccessible: ROLE_FEATURES['policy_terms_finalized'],
            },
            {
                name: translations.Insurance?.['Insurance Policy Shared'] || translations.commonMsg?.loading,
                key: "insurance_policy_shared",
                isVisible: FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['INSURANCE_POLICY_SHARED'],
                order: 5,
                child: [],
                url: `/details/insurance-policy-shared/${insuranceState.leadDetail.hashId}`,
                activeRoutes: ['insurance-policy-shared'],
                isClickable: ((allStatus && allStatus.includes(`3-${STATUS_SUB_STATUS['subStatus']['policy_terms_finalized']}`)) || insuranceState.leadDetail.policy_generate_id) ? true : false,//,
                completedOnSubStatus: ((allStatus && allStatus.includes('3-5')) || insuranceState.leadDetail.policy_shared_customer_source || insuranceState.leadDetail.is_policy_shared_agent || insuranceState.leadDetail.is_policy_shared_to_agency_officer) ? true : false,//STATUS_SUB_STATUS['subStatus']['policy_shared'],
                isLinkAccessible: ROLE_FEATURES['insurance_policy_shared']
            },
            {
                name: translations.Insurance?.['Insurance Premium Payment'] || translations.commonMsg?.loading,
                key: "insuance_premium_payment",
                isVisible: FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['INSURANCE_PREMIUM_PAYMENT'],
                order: 6,
                child: [],
                url: `/details/insurance-premium-payment/${insuranceState.leadDetail.hashId}`,
                activeRoutes: ['insurance-premium-payment'],
                isClickable: (isLeadPushToColl) ? false :((allStatus && allStatus.includes('3-5')) || insuranceState.leadDetail.policy_shared_customer_source || insuranceState.leadDetail.is_policy_shared_agent || insuranceState.leadDetail.is_policy_shared_to_agency_officer) ? true : false,//,
                completedOnSubStatus: (isLeadPushToColl) ? false :(allStatus && (allStatus.includes('4-6') || allStatus.includes('4-7'))) || insuranceState.leadDetail.is_insurance_premium_payment ? true : false,
                isLinkAccessible: ROLE_FEATURES['insurance_premium_payment'],

            },
            {
                name: translations.Insurance?.['Incentive Payment'] || translations.commonMsg?.loading,
                key: "incentive-payment",
                isVisible: FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['INCENTIVE_PAYMENT'],
                order: 7,
                child: [],
                url: `/details/incentive-payment/${insuranceState.leadDetail.hashId}`,
                activeRoutes: ['incentive-payment'],
                isClickable: (isLeadPushToColl) ? false : (allStatus && (allStatus.includes('4-6') || allStatus.includes('4-7'))) || insuranceState.leadDetail.is_insurance_premium_payment ? true : false,
                completedOnSubStatus: (isLeadPushToColl) ? false : (allStatus && allStatus.includes('5-8')) || insuranceState.leadDetail.is_incentive_payment ? true : false,//STATUS_SUB_STATUS['subStatus']['policy_generated'],
                isLinkAccessible: ROLE_FEATURES['incentive-payment'],
            },
            {
                name: translations.Insurance?.['Insurer Partner Payment'] || translations.commonMsg?.loading,
                key: "insurer-partner-payment",
                isVisible: FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['INSURER_PARTNER_PAYMENT'],
                order: 8,
                child: [],
                url: `/details/insurer-partner-payment/${insuranceState.leadDetail.hashId}`,
                activeRoutes: ['insurer-partner-payment'],
                // activeOnSubStatus: STATUS_SUB_STATUS['subStatus']['policy_generated'],
                // clickablenSubStatus: STATUS_SUB_STATUS['subStatus']['soft_approval_received'],
                isClickable: (isLeadPushToColl) ? false : ((allStatus && allStatus.includes('5-8')) || insuranceState.leadDetail.is_incentive_payment),//,
                completedOnSubStatus: (isLeadPushToColl) ? false : ((allStatus && allStatus.includes('6-9')) || insuranceState.leadDetail.status_id === STATUS_SUB_STATUS['status']['insurer_partner_payment']),//STATUS_SUB_STATUS['subStatus']['policy_generated'],
                isLinkAccessible: true//ROLE_FEATURES['insurance_premium_payment'],
            },
        ];

        let updatedSideBar: any = [];
        let subStatusId = +insuranceState.leadDetail.sub_status_id;
        let statusId = +insuranceState.leadDetail.status_id;
        for (let elm of updatedLeftBar) {
            // let elmData = elm;
            if (+statusId === STATUS_SUB_STATUS['status']['lost']) {
                subStatusId = insuranceState?.leadDetail?.prev_sub_status_id;
            }

            //MAKE NAVLINK CLICKABLE BASED ON SUBSTATUS
            if (subStatusId >= elm.activeOnSubStatus) {
                // elm['isClickable'] = true;
                // elm['isVisible'] = true;

            }

            if (subStatusId >= elm.clickableOnSubStatus) {
                // elm['isClickable'] = true;
                // elm['isVisible'] = true;
            }

            if (+insuranceState?.leadDetail['doc_status_id'] !== 3 && !["customer_details", "sent_to_insurace_broker"].includes(elm['key'])) {
                elm['isClickable'] = false;
            }
            updatedSideBar.push(elm)
        }

        updatedSideBar = updatedSideBar.sort((a: any, b: any) => a.order - b.order);
        setLeftSideTabs([...updatedSideBar])
        // }
        // eslint-disable-next-line
    }, [insuranceState.getInboundPaymentFrom, insuranceState.leadDetail,translations])

    const showModalMarkAsLost = (set: boolean) => {
        setMarkLostPopup(set)
    }

    const showReopenPopup = (set: boolean) => {
        setReopenPopup(set)
    }
    const pageSwitch = (param: string, cases: { [key: string]: any }) => {
        if (cases[param]) {
            return cases[param]
        } else {
            return cases.default
        }
    }

    const navClickHandler = (e: any, navElement: any) => {

        if (!navElement.isClickable) e.preventDefault();

        if (navElement.type && navElement.type === "toggleHandler") {
            e.preventDefault();

            setMenuExpanded({ ...menuExpanded, [navElement.key]: !menuExpanded[navElement.key] })

        }
    }

    const getTabClass = (elm: any) => {

        // let subStatusId = (insuranceState.leadDetail && insuranceState.leadDetail.sub_status_id) ? +insuranceState.leadDetail.sub_status_id : 0;
        let prevStatusId = (insuranceState.leadDetail && insuranceState.leadDetail.prev_status_id) ? +insuranceState.leadDetail.prev_status_id : 0;
        let statusId = (insuranceState.leadDetail && insuranceState.leadDetail.status_id) ? +insuranceState.leadDetail.status_id : 0;

        // if (+statusId === STATUS_SUB_STATUS['status']['lost']) {
        //     subStatusId = insuranceState?.leadDetail?.prev_sub_status_id;
        // }

        let classname = '';
        if (elm['activeRoutes'].includes(subRoute)) {

            classname = "active";
        }

        //FOR INSURANCE POLICY SHARED EQUAL VALUES ARE MATCHING
        if (elm.key === "insurance_policy_shared") {
            // if(subStatusId == elm.completedOnSubStatus){
            if (insuranceState.leadDetail.policy_shared_customer_source || (allStatus && allStatus.includes('3-7')) || insuranceState.leadDetail.is_policy_shared_agent) {
                classname += " completed";
            }

        } else if (elm.key === "outbound_payment" && +insuranceState.leadDetail.inbound_payment_from === 3 && insuranceState.leadDetail.outbound_broker_id) { //IF FROM CUSTOMER AND BROKER AMOUNT PAID
            classname += " active";
            if (insuranceState.leadDetail.outbound_sales_team_id || (allStatus && allStatus.includes('5-12'))) {
                classname += " completed";

            }

        } else {
            //CHECK IF SUBSTATUS IS GREATER THAN COMPLETED
            if (prevStatusId && prevStatusId !== 6 && +statusId === 6 && elm.completedOnSubStatus) {
                // && ![13, 14,15,16,17,18,19,20].includes(+subStatusId)) {

                classname += " completed";

            } else if (statusId !== 6 && elm.completedOnSubStatus) {
                // && ![13, 14,15,16,17,18,19,20].includes(+subStatusId)) {
                classname += " completed";

            }
        }

        if (+insuranceState.leadDetail['soft_approval_is_skipped'] && elm['isSkippable']) {
            classname = "active completed";

        }
        // console.log(elm, classname, subStatusId, insuranceState.leadDetail)
        // if(elm.key=="payment_from_broker") console.log(elm, classname, subStatusId)

        if (!HELPER.isUserHasUpdateAccess({ permissionID: elm.isLinkAccessible, accessType: 'isVisible', leadDetails: insuranceState?.leadDetail })) {
            classname = "hide";

        }
        return classname;

    }

    let showMarkAsLost = (statusId < STATUS_SUB_STATUS['status']['lost']) ? true : false;            // after payment is done hide mark as lost button 

    let showReopen = true;
    if(prevStatusId && +prevStatusId === STATUS_SUB_STATUS['status']['insurance_policy']){
        showReopen = false;
    }
    if(prevStatusId && +prevStatusId > STATUS_SUB_STATUS['status']['insurance_policy'] && +currSubStatusId === STATUS_SUB_STATUS['subStatus']['insurance_policy_cancelled']){
        showReopen = false;
    }

    return (
        <div className="lead-detail-tabs">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first" activeKey={activeTab}>

                <Nav variant="pills" className="flex-column" onSelect={(e: any) => setActiveTab(e)}>
                    <div className="tab-list">
                        <Nav.Item>
                            <Nav.Link eventKey="first">{translations.Insurance?.['Insurance Details'] || translations.commonMsg?.loading}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="second">{translations.Insurance?.['Quote Details'] || translations.commonMsg?.loading}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="third">{translations.Insurance?.['Docs Upload'] || translations.commonMsg?.loading}</Nav.Link>
                        </Nav.Item>
                    </div>
                    {statusId && +statusId !== STATUS_SUB_STATUS['status']['lost'] && showMarkAsLost && HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['lost'], accessType: 'isVisible' }) && (([APP_TYPE_STANDALONE, APP_TYPE_AGENCY].includes(insuranceState?.leadDetail?.application_type_id) && insuranceState?.leadDetail?.agency_id && ![AGENCY_STATUS['inprogress'], AGENCY_STATUS['rejected']].includes(+insuranceState?.leadDetail?.agency_status)) || [APP_TYPE_STANDALONE, APP_TYPE_AGENCY].includes(insuranceState?.leadDetail?.application_type_id)) ? <button className="lost-btn" onClick={() => showModalMarkAsLost(true)}>{translations.Insurance?.['Mark as Lost'] || translations.commonMsg?.loading}</button> : ""}

                    {statusId && +statusId === STATUS_SUB_STATUS['status']['lost'] && showReopen && HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['re-open'], accessType: 'isVisible' }) ? <button className="reopen-btn" onClick={() => showReopenPopup(true)}> {translations.Insurance?.['Re-Open'] || translations.commonMsg?.loading}</button> : ""}

                </Nav>

                <Tab.Content>
                    <Tab.Pane eventKey="first">
                        <div className="detail-form-sec">

                            <div className={`menu-tab-left-panel ${(+insuranceState.leadDetail.application_type_id === APP_TYPE_AGENCY) ? "menu-tab-left-panel-agency" : ""}`}>
                                <div className="dealer-tab-left-panel nav">
                                    <ul>

                                        {
                                            leftSideTabs.map((elm: any, key: number) => {

                                                return elm.child.length && elm.isVisible
                                                    ?
                                                    <li key={elm.key}>
                                                        <Dropdown data-id={menuExpanded[elm.key]} className={` ${getTabClass(elm)} d-inline mx-2 ${(!menuExpanded[elm.key] ? 'shows' : '')}`} autoClose={false} show={menuExpanded[elm.key]} >
                                                            <Dropdown.Toggle id="dropdown-autoclose-false " onClick={(e) => navClickHandler(e, { ...elm, type: 'toggleHandler' })}>

                                                                <span className="img-type"></span>
                                                                {elm.name}

                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu >

                                                                <ul>
                                                                    {
                                                                        elm.child.map((el: any) =>
                                                                            el.isVisible && <li key={el.key}>
                                                                                <NavLink to={el['url']}
                                                                                    onClick={(e) => navClickHandler(e, el)}
                                                                                    className={getTabClass(el)}

                                                                                >
                                                                                    <span className="img-type"></span>
                                                                                    {el.name}
                                                                                </NavLink>

                                                                            </li>
                                                                        )
                                                                    }

                                                                </ul>

                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </li>
                                                    :
                                                    elm.isVisible && <li key={elm.key}>
                                                        <NavLink to={`${elm['url']}`}
                                                            className={getTabClass(elm)}

                                                            onClick={(e) => navClickHandler(e, elm)}>
                                                            <span className="img-type"></span>
                                                            {elm.name}</NavLink>
                                                    </li>

                                            })
                                        }

                                    </ul>

                                </div>
                            </div>
                            <div className="route-files">
                                {
                                    leadHashId && pageSwitch(subRoute, {
                                        "personal-details": <CustomerDetails formType={subRoute} leadHashId={props.leadHashId} />,
                                        "residential-details": <CustomerDetails formType={subRoute} leadHashId={props.leadHashId} />,
                                        "vehicle-details": <CustomerDetails formType={subRoute} leadHashId={props.leadHashId} />,
                                        "other-details": <CustomerDetails formType={subRoute} leadHashId={props.leadHashId} />,
                                        "payment-details": <CustomerDetails formType={subRoute} leadHashId={props.leadHashId} />,
                                        "sent-to-insurance-broker": <SentToInsuranceBroker formType={subRoute} leadHashId={props.leadHashId} getDetails={props.getDetails} />,
                                        "insurance-policy-shared": <InsurancePolicyShared formType={subRoute} activeTab={activeTab} leadHashId={props.leadHashId} />,
                                        "soft-approval-received": <UsePolicyForm formType={subRoute} />,
                                        "insurance-policy-generated": <UsePolicyForm formType={subRoute} />,
                                        "policy-terms-finalized": <PolicyTermsFinalizedForm formType={subRoute} leadHashId={props.leadHashId} setTopLevelTab={setActiveTab} activeTab={activeTab} />,
                                        "insurance-premium-payment": <InsurancePremiumPayment formType={subRoute} leadHashId={leadHashId} payment_type={1} />,
                                        "incentive-payment": <InsurancePremiumPayment formType={subRoute} />,
                                        "payment-from-customer-to-partner-broker": <PaymentType formType={1} leadHashId={leadHashId} payment_type={3} />,
                                        "payment-customer": <PaymentType formType={3} leadHashId={leadHashId} payment_type={1} />,
                                        "payment-sales-team": <PaymentType formType={2} leadHashId={leadHashId} payment_type={1} />,
                                        "payment-broker": <PaymentType formType={1} leadHashId={leadHashId} payment_type={1} />,
                                        "payment-to-broker": <PaymentType formType={1} leadHashId={leadHashId} payment_type={2} />,
                                        "payment-to-sales-team": <PaymentType formType={2} leadHashId={leadHashId} payment_type={2} />,

                                        "payment-from-agency-to-oto-insurance": <AgencyInboundOutBoundPayment payment_type={INBOUND_PAYMENT_FROM_OTO_INSURANCE} leadHashId={leadHashId} formType={INSURANCE_PAYMENT_FROM_AGENCY_TO_OTO_INSURANCE} />,
                                        "payment-from-oto-to-insurance-partner": <AgencyInboundOutBoundPayment payment_type={INBOUND_PAYMENT_FROM_OTO_INSURANCE} leadHashId={leadHashId} formType={INSURANCE_PAYMENT_FROM_OTO_TO_INSURANCE_PARTNER} />,
                                        "payment-from-agency-to-insurance-partner": <AgencyInboundOutBoundPayment payment_type={INBOUND_PAYMENT_FROM_INSURANCE_PARTNER} leadHashId={leadHashId} formType={INSURANCE_PAYMENT_FROM_AGENCY_TO_INSURANCE_PARTNER} />,
                                        "payment-from-insurance-partner-to-oto": <AgencyInboundOutBoundPayment payment_type={INBOUND_PAYMENT_FROM_INSURANCE_PARTNER} leadHashId={leadHashId} formType={INSURANCE_PAYMENT_FROM_INSURANCE_PARTNER_TO_OTO} />,
                                        "referral-fee-payout": <AgencyInboundOutBoundPayment formType={REFERRAL_FEE_PAYOUT} leadHashId={leadHashId} payment_type={REFERRAL_FEE_PAYOUT_OUTBOUND} />,

                                        "insurer-partner-payment": <InsurerPartnerPayment formType={subRoute} />,

                                        default: <CustomerDetails formType={subRoute} leadHashId={props.leadHashId} />
                                    })
                                }

                            </div>
                        </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                        {
                            activeTab && activeTab === 'second' ?
                                <LoanExpected />
                                : null
                        }
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                        {
                            activeTab && activeTab === 'third' ?
                                <DocumentUpload formType={subRoute} />
                                : null
                        }
                    </Tab.Pane>
                </Tab.Content>

            </Tab.Container>
            {markLostPopup ?
                <MarkAsLostPopup
                    markLostPopup={markLostPopup}
                    showModalMarkAsLost={(e: boolean) => showModalMarkAsLost(e)}
                    statusId={statusId}
                    leadHashId={leadHashId} /> : ''}

            {reopenPopup ?
                <ReopenPopup
                    reopenPopup={reopenPopup}
                    showReopenPopup={(e: boolean) => showReopenPopup(e)}
                    leadHashId={leadHashId} /> : ''}

        </div >
    )
}
